import { render, staticRenderFns } from "./recordsPage.vue?vue&type=template&id=76cd4f44&scoped=true"
import script from "./recordsPage.vue?vue&type=script&lang=js"
export * from "./recordsPage.vue?vue&type=script&lang=js"
import style0 from "./recordsPage.vue?vue&type=style&index=0&id=76cd4f44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cd4f44",
  null
  
)

export default component.exports